// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__iG7Ao","label":"Section_label__25_k0","contentWrap":"Section_contentWrap__3GTbr","footer":"Section_footer__1O7Pb","footerInner":"Section_footerInner__Alwb7"};